export const EXPERIMENTAL_WIDGETS = {
  fallRisk: 'fall-risk-quantification',
  MM4PDFluctuation: 'mm4pd-fluctuation',
  symptomBurdenRisk: 'symptom-burden-risk',
}

export const EXPERIMENTAL_WIDGET_TITLES = {
  [EXPERIMENTAL_WIDGETS.fallRisk]: 'Fall Risk Quantification',
  [EXPERIMENTAL_WIDGETS.MM4PDFluctuation]: 'Medication Response',
  [EXPERIMENTAL_WIDGETS.symptomBurdenRisk]: 'Symptom Burden Risk',
}
